<template>
  <basic-container>
    <!-- ------搜索栏功能 -------->
    <div class="query-form-wrap">
      <div class="query-form-wrap-left">
        <el-form :inline="true" :model="searchForm" :size="formSize">
          <el-form-item label="媒资名称">
            <el-input clearable v-model="searchForm.name" placeholder="请输入媒资名称">
            </el-input>
          </el-form-item>
          <el-form-item label="明星">
            <el-input clearable v-model="searchForm.staffMemberName" placeholder="请输入明星姓名"></el-input>
          </el-form-item>
          <el-form-item size="small" label="媒资类型">
            <el-select v-model="searchForm.type" clearable placeholder="全部">
              <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small" label="状态" prop="channelNameStr">
            <el-select v-model="searchForm.status" clearable placeholder="全部">
              <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small" label="来源" prop="channelNameStr">
            <el-select v-model="searchForm.sourceType" clearable placeholder="全部">
              <el-option v-for="item in sourceType" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small" label="年份" prop="channelNameStr">
            <el-select v-model="searchForm.year" clearable placeholder="全部">
              <el-option v-for="item in year" :key="item.value" :label="item.dictValue" :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="handleSearch"
                v-auth="'MARKMANAGE_MEDIAMANAGE_SEARCH'">搜索</el-button>
              <el-button icon="el-icon-delete" @click="handleClear">清空</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- //^ ^--------------表格 start-------------^ ^ -->
    <div>
      <el-button v-auth="'MARKMANAGE_MEDIAMANAGE_ADD'" size="small" type="primary"
        @click="addDialog = true">新增</el-button>
    </div>
    <br />
    <el-table height="550" :data="mediaData" @selection-change="handleSelectionChange" border style="width: 100%">
      <el-table-column type="index" width="50" label="序号"> </el-table-column>
      <el-table-column width="80" prop="coverImage" label="媒资图片">
        <template v-slot="data">
          <!-- <el-image :src="data.row.coverImage" alt="" /> -->
          <div style="display: flex; ">
            <ImageIframe style="width: 75px; height: 70px;" v-if="isShowIframe" :url="data.row.coverImage">
            </ImageIframe>
          </div>

        </template>
      </el-table-column>
      <el-table-column width="150" prop="name" label="媒资名称"> </el-table-column>
      <el-table-column width="100" prop="type" label="媒资类型">
        <template v-slot="data">
          {{ valueToLabel(typeOptions, data.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="year" label="年份">
      </el-table-column>
      <el-table-column prop="sourceType" label="来源">
        <template v-slot="data">
          {{ valueToLabel(payStatusOptions, data.row.payType) + valueToLabel(sourcePlatformOptions, data.row.sourceType)
          }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template v-slot="data">
          {{ valueToLabel(statusOptions, data.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="primary" label="是否主媒资">
        <template v-slot="data">
          {{ valueToLabel(primaryOptions, data.row.primary) }}
        </template>
      </el-table-column>
      <el-table-column label="媒资标签">
        <template v-slot="data">
          <div>
            <el-popover placement="top-start" trigger="hover" :content="data.row.tagName">
              <div slot="reference" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                <el-tag style="margin-right: 10px;" v-for="item in data.row.tagName.split(',')" :key="item.id">
                  {{ item }}
                </el-tag>
              </div>

            </el-popover>
          </div>
        </template>
      </el-table-column>


      <el-table-column prop="updateTime" label="最后更新时间" width="180">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row.id)"
            v-auth="'MARKMANAGE_MEDIAMANAGE_EDIT'">编辑</el-button>
          <el-button type="text" size="small" @click="handleView(scope.row.id)"
            v-auth="'MARKMANAGE_MEDIAMANAGE_VIEW'">查看</el-button>
          <el-button v-show="scope.row.status === 2" type="text" size="small" v-auth="'MARKMANAGE_MEDIAMANAGE_STATE'"
            @click="handleTakeOn(scope.row.id)">上架</el-button>
          <el-button v-show="scope.row.status === 1" type="text" size="small" v-auth="'MARKMANAGE_MEDIAMANAGE_STATE'"
            @click="handleTakeOff(scope.row.id)">下架</el-button>
          <el-button v-show="scope.row.primary === true" type="text" size="small"
            v-auth="'MARKMANAGE_MEDIAMANAGE_CONTACT'" @click="handleCorrelate(scope.row.id)">关联</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- //^ ^--------------表格 end-------------^ ^ -->

    <!-- //^ ^--------------查看/编辑的对话框-------------^ ^ -->
    <el-dialog v-if="editDialog" :title="disabled === false ? '编辑' : '查看'" :visible.sync="editDialog" width="60%"
      :before-close="handleClose" :modal-append-to-body="false" @closed="closeDialog">
      <el-form ref="editForm" :model="editForm" :rules="editRules">
        <el-form-item prop="mediaAsset.name" label="媒资名称:" label-width="20%">
          <el-input show-word-limit :disabled="disabled" maxlength="50" type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }" v-model="editForm.mediaAsset.name" placeholder="请输入媒资名称"></el-input>
        </el-form-item>
        <el-form-item prop="mediaAsset.aliasName" label="媒资别名:" label-width="20%">
          <el-input show-word-limit :disabled="disabled" maxlength="50" type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }" v-model="editForm.mediaAsset.aliasName" :placeholder="editForm.mediaAsset.aliasName
              ? editForm.mediaAsset.aliasName
              : '暂无媒资别名'
              "></el-input>
        </el-form-item>
        <el-form-item prop="mediaAsset.type" label="媒资类型:" label-width="20%">
          <span>{{ editForm.mediaAsset.type }}</span>
        </el-form-item>
        <el-form-item prop="drama.episodes" label="集数:" label-width="20%">
          <span>{{
            editForm.drama.episodes ? editForm.drama.episodes : "集数未知"
          }}</span>
        </el-form-item>
        <el-form-item prop="mediaAsset.description" label="简介:" label-width="20%">
          <el-input show-word-limit :disabled="disabled" maxlength="500" type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }" v-model="editForm.mediaAsset.description"
            placeholder="请输入简介"></el-input>
        </el-form-item>
        <!-- //^ ^--------------封面图-------------^ ^ -->
        <el-form-item prop="mediaAsset" label="简介:" label-width="20%">
          <div class="showMediaImg">
            <div class="showMediaImg-left">
              <span>封面图: </span>
              <ImageIframe v-if="editForm.mediaAsset.isShowCoverImage" :url="editForm.mediaAsset.coverImage"
                option="coverImage">
              </ImageIframe>
              <span v-if="!editForm.mediaAsset.coverImage">暂无图片</span>
              <el-upload v-show="!disabled" class="upload-demo" :before-upload="checkUpload" :http-request="upload"
                listType="picture-img" action="coverImage" :on-preview="handlePreview" :on-remove="handleRemove"
                :before-remove="beforeRemove" :on-exceed="handleExceed" :show-file-list="false">
                <el-button size="small" type="primary">重新上传</el-button>
              </el-upload>
            </div>
            <div class="showMediaImg-right">
              <span>高清横屏图: </span>
              <ImageIframe v-if="editForm.mediaAsset.isShowHdImage" :url="editForm.mediaAsset.hdImage" option="hdImage">
              </ImageIframe>

              <div class="mediaImg iframeClass" :id="editForm.mediaAsset.hdImage"></div>
              <span v-if="!editForm.mediaAsset.hdImage">暂无图片</span>
              <el-upload v-show="!disabled" class="upload-demo" :before-upload="checkUpload" :http-request="upload"
                listType="picture-img" action="hdImage" :on-preview="handlePreview" :on-remove="handleRemove"
                :before-remove="beforeRemove" :data="editForm.mediaAsset.hdImage" :on-exceed="handleExceed"
                :show-file-list="false">
                <el-button size="small" type="primary">重新上传</el-button>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="mediaAsset.score" label="评分:" label-width="20%">
          {{ editForm.mediaAsset.score }}
        </el-form-item>
        <el-form-item prop="mediaAsset.url" label="页面访问地址:" label-width="20%">
          {{ editForm.mediaAsset.url }}
        </el-form-item>
        <el-form-item prop="mediaAsset.urlScheme" label="app跳转地址:" label-width="20%">
          {{ editForm.mediaAsset.urlScheme }}
        </el-form-item>
        <el-form-item prop="mediaAsset.tagName" label="备注:" label-width="20%">
          <el-input show-word-limit :disabled="disabled" maxlength="99" type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }" v-model="editForm.mediaAsset.tagName" :placeholder="editForm.mediaAsset.tagName
              ? editForm.mediaAsset.tagName
              : '暂无备注'
              "></el-input>
        </el-form-item>
        <el-form-item prop="mediaAsset.sourceType" label="来源平台:" label-width="20%">
          {{ editForm.mediaAsset.sourceType }}
        </el-form-item>
        <!-- //^ ^--------------演职员表-------------^ ^ -->
        <div style="width: 100%; max-height: 31.25rem; overflow: auto">
          <el-form-item prop="staffMembers" label="明星列表:" label-width="20%">
            <div class="showMediaImg" v-if="editForm.staffMembers.length">
              <div v-for="item in editForm.staffMembers" :key="item.id" class="showMediaImg-left">
                <ImageIframe v-if="item.isShowIframe" :url="item.headImage" option="headImage"></ImageIframe>
                <span v-if="!item.headImage">暂无图片</span>
                <div :id="item.id"></div>
                <p>演员：{{ item.name }}</p>
                <p style="margin-top: -1.25rem">职务：{{ item.position }}</p>
                <el-upload v-show="!disabled" class="upload-demo" :before-upload="checkUpload" :http-request="upload"
                  listType="picture-img" :data="`${item.id}`" action="headImage" :on-preview="handlePreview"
                  :on-remove="handleRemove" :before-remove="beforeRemove" :on-exceed="handleExceed"
                  :show-file-list="false">
                  <el-button size="small" type="primary">重新上传</el-button>
                </el-upload>
              </div>
            </div>
            <div v-else>暂无数据</div>
          </el-form-item>
        </div>

        <!-- //^ ^--------------剧集列表-------------^ ^ -->
        <div style="
            width: 100%;
            max-height: 31.25rem;
            overflow: auto;
            margin-top: 3.125rem;
          ">
          <el-form-item prop="mediaAsset.sourceType" label="剧集列表:" label-width="20%">
            <el-table :data="editForm.episodes" border style="width: 100%">
              <el-table-column prop="episodeName" label="集名">
              </el-table-column>
              <el-table-column prop="duration" label="时长"> </el-table-column>
              <el-table-column prop="url" label="页面访问地址">
              </el-table-column>
              <el-table-column prop="urlScheme" label="app跳转地址">
              </el-table-column>
              <!-- <el-table-column prop="episodeType" label="类型">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        </el-table-column> -->
            </el-table>
          </el-form-item>
        </div>
      </el-form>
      <span v-show="!disabled" slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="editDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- //^ ^--------------关联媒资的对话框-------------^ ^ -->
    <el-dialog title="关联媒资" :visible.sync="correlateDialog" width="80%" :modal-append-to-body="false"
      @closed="correlateDialogCancel" @open="openEvent">
      <el-table ref="mediaTable" :data="correlateData" border style="width: 100%" @select-all="handleSelectionChange"
        @select="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="媒资名称" width="180">
        </el-table-column>
        <el-table-column prop="sourceType" label="来源平台" width="100">
        </el-table-column>
        <el-table-column prop="tagName" label="标签" width="150">
          <template slot-scope="scope">
            <div>
              <el-tag style="margin-right: 10px; margin-bottom: 5px" v-for="item in scope.row.tagName.split(',')"
                :key="item.id">
                {{ item }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column class="correlate-description" min-width="80" :show-overflow-tooltip="true" prop="description"
          label="描述">
        </el-table-column>
        <el-table-column prop="primary" label="主媒资" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.primary" @change="handlePrimary(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="correlateDialogCancel">取 消</el-button>
        <el-button type="primary" @click="correlateDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- //^ ^--------------新增媒资的对话框-------------^ ^ -->
    <el-dialog title="新增媒资" :visible.sync="addDialog" width="40%" :modal-append-to-body="false" @closed="addDialogCancel">
      <div class="add-container">
        <el-form ref="addForm" :model="addForm" :rules="addRules">
          <el-form-item label="输入url链接:" label-width="20%" prop="url">
            <el-input style="width: 90%" v-model="addForm.url" clearable placeholder="请输入url链接"></el-input>
          </el-form-item>

        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogCancel">取 消</el-button>
        <el-button type="primary" @click="addDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- //^ ^--------------分页 start-------------^ ^ -->
    <br />
    <div class="pagination" style="text-align: right">
      <ElementPagination :current-page="searchForm.current" :page-size="searchForm.size" :total="searchForm.total"
        :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
    <br />
    <!-- //^ ^--------------分页 end-------------^ ^ -->
  </basic-container>
</template>

<script>
import {
  getMediaData,
  getMediaDetail,
  takeOnMedia,
  takeOffMedia,
  getCorrelateMedia,
  updateMedia,
  setCorrelateMedia,
  addMediaBySpider,
  getMediaByUrl,
  getYear
} from "@/api/markManage/mediaManage";
import axios from "axios";
import moment from "moment";
import mixins from "./utils/mixins";
import ElementPagination from "@/components/ElementPagination";
import ImageIframe from "./img_iframe.vue";
import Message from "@/components/Message";
export default {
  name: "WebSassMediaManage",
  mixins: [mixins],
  components: {
    ElementPagination,
    ImageIframe
  },
  data() {
    return {
      /** */
      isShowIframe: false,
      /** 搜索栏 */
      formSize: "small",
      searchForm: {
        name: null,
        type: null,
        sourceType: null,
        staffMemberName: null,
        status: null,
        year: null,
        current: 1,
        size: 10,
        total: 0
      },
      /** 媒资类型 */
      type: [
        {
          label: "电视剧",
          value: 1
        },
        {
          label: "电影",
          value: 2
        },
        {
          label: "综艺",
          value: 3
        },
        {
          label: "少儿",
          value: 4
        }
      ],
      /** 来源平台 */
      sourceType: [
        {
          label: "腾讯",
          value: 1
        },
        {
          label: "优酷",
          value: 2
        },
        {
          label: "爱奇艺",
          value: 3
        },
        {
          label: "bilibili",
          value: 8
        }
      ],
      /** 媒资状态 */
      status: [
        {
          label: "上架",
          value: 1
        },
        {
          label: "下架",
          value: 2
        }
      ],
      /** 年份 */
      year: [],
      /** 表格展示的数据 */
      mediaData: [],
      /** 编辑/查看 对话框 */
      editDialog: false,
      /** 是否禁止修改 */
      disabled: false,
      /** 初始值 */
      editForm: {
        drama: {
          createTime: "",
          episodes: 0,
          id: 0,
          isEnd: 0,
          updateInstruction: "",
          updateTime: "",
          updatedEpisodes: 0
        },
        episodes: [
          {
            createTime: "",
            duration: 0,
            episodeName: "",
            externalEpisodeMediaId: "",
            id: 0,
            mediaId: 0,
            orderNum: 0,
            updateTime: "",
            url: "",
            urlScheme: ""
          }
        ],
        mediaAsset: {
          aliasName: "",
          coverImage: "",
          createTime: "",
          description: "",
          duration: 0,
          externalMediaId: "",
          hasRelated: true,
          hdImage: "",
          id: 0,
          isDeleted: 0,
          language: "",
          name: "",
          primary: true,
          productionCountry: "",
          score: 0,
          sourceType: 0,
          status: 0,
          tagName: "",
          type: 0,
          updateTime: "",
          url: "",
          urlScheme: ""
        },
        staffMembers: [
          {
            createTime: "",
            headImage: "",
            id: 0,
            isDeleted: 0,
            mediaId: 0,
            name: "",
            orderNum: 0,
            position: 0,
            updateTime: ""
          }
        ]
      },
      /** 编辑表单校验规则 */
      editRules: {
        "mediaAsset.name": [
          { required: true, message: "请输入媒资名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur"
          }
        ]
      },
      /** 初始值 */
      initData: {
        drama: {
          createTime: "",
          episodes: 0,
          id: 0,
          isEnd: 0,
          updateInstruction: "",
          updateTime: "",
          updatedEpisodes: 0
        },
        episodes: [
          {
            createTime: "",
            duration: 0,
            episodeName: "",
            externalEpisodeMediaId: "",
            id: 0,
            mediaId: 0,
            orderNum: 0,
            updateTime: "",
            url: "",
            urlScheme: ""
          }
        ],
        mediaAsset: {
          aliasName: "",
          coverImage: "",
          createTime: "",
          description: "",
          duration: 0,
          externalMediaId: "",
          hasRelated: true,
          hdImage: "",
          id: 0,
          isDeleted: 0,
          language: "",
          name: "",
          primary: true,
          productionCountry: "",
          score: 0,
          sourceType: 0,
          status: 0,
          tagName: "",
          type: 0,
          updateTime: "",
          url: "",
          urlScheme: ""
        },
        staffMembers: [
          {
            createTime: "",
            headImage: "",
            id: 0,
            isDeleted: 0,
            mediaId: 0,
            name: "",
            orderNum: 0,
            position: 0,
            updateTime: ""
          }
        ]
      },
      /** 关联媒资对话框 */
      correlateDialog: false,
      /** 关联媒资的数据 */
      correlateData: [],
      /** 关联的id数组 */
      correlateIds: [],
      /** 选中的媒资信息 */
      selectMedia: [],
      /** 主媒资个数 */
      primaryCount: 0,
      /** 主媒资id */
      primaryId: "",
      /** 新增对话框的显示 */
      addDialog: false,
      /** 新增对话框的内容 */
      addForm: {
        url: ""
      },
      /** 新增媒资的表单验证 */
      addRules: {
        url: [{ required: true, message: "请输入媒资地址", trigger: "blur" }]
      },
    };
  },
  created() {
    /** 渲染列表 */
    this.loadMediaData();
  },
  mounted() { },

  methods: {
    /** load媒资库数据 */
    async loadMediaData() {
      this.isShowIframe = false
      const { data } = await getMediaData(this.searchForm);
      /** 拿到年份 */
      const res = await getYear();
      console.log('查询年份', res.data.data[0]);
      /** 处理年份 */
      this.year = res.data.data[0].children
      /** 对数据进行处理 */
      const list = data.data.records;
      this.searchForm.total = data.data.total;
      /** 数据赋值 */
      this.mediaData = list;
      /** iframe */
      this.isShowIframe = true
    },
    //^ ^--------------搜索栏相关 start-------------^ ^
    /** 条件搜索 */
    handleSearch() {
      this.loadMediaData();
      /**提示用户 */
      Message.success('检索成功')
    },
    /** 清空搜索栏 */
    handleClear() {
      Message.success('清空成功')
      this.searchForm = {
        name: null,
        type: null,
        sourceType: null,
        staffMemberName: null,
        current: 1,
        size: 10,
        total: 0
      };
    },
    //^ ^--------------搜索栏相关 end-------------^ ^

    //^ ^--------------表格相关 start-------------^ ^
    /** 上传图片校验 */
    checkUpload(file) {
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.error("目前只支持jpeg/png图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024) {
        this.$message.error("不能上传超过1M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params) {
      if (params.action === "coverImage") {
        this.editForm.mediaAsset.isShowCoverImage = false;
      }
      if (params.action === "hdImage") {
        this.editForm.mediaAsset.isShowHdImage = false;
      }

      /** 处理演员职务 */
      this.editForm.staffMembers.forEach(item => {
        if (item.id === params.data) item.isShowIframe = false;
      });
      const file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
        console.log("重新上传的响应", data);
        const result = data.data;
        /** 判断action 修改对应的图片地址 */
        /** 修改封面图 */
        if (params.action === "coverImage") {
          this.editForm.mediaAsset.isShowCoverImage = true;
          this.editForm.mediaAsset.coverImage = result.link;
          // this.editForm.mediaAsset.coverImage = result.link.replace(/"/g, "");
        } else if (params.action === "hdImage") {
          this.editForm.mediaAsset.isShowHdImage = true;
          this.editForm.mediaAsset.hdImage = result.link;
          // this.editForm.mediaAsset.hdImage = result.link.replace(/"/g, "");
        } else if (params.action === "headImage") {
          /** 根据id修改演员头像 */
          this.editForm.staffMembers.forEach(item => {
            if (item.id === params.data) {
              item.isShowIframe = true;
              item.headImage = result.link;
              // item.headImage = result.link.replace(/"/g, "");
            }
          });
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    /** 查看媒资 */
    async handleView(id) {
      await this.backFillData(id);
      /** 查看禁止修改 */
      this.disabled = true;
      /** show对话框 */
      this.editDialog = true;
    },
    /** 编辑媒资 */
    async handleEdit(id) {
      await this.backFillData(id);
      /** 编辑允许修改 */
      this.disabled = false;
      /** show对话框 */
      this.editDialog = true;
    },
    /** 上架媒资 */
    handleTakeOn(id) {
      this.$confirm("此操作将上架该媒资, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          /** 上架媒资 */
          const res = await takeOnMedia(id);
          if (res.data.code === 200) {
            Message.success('上架成功')
            this.loadMediaData();
          } else {
            Message.error('上架失败')
          }
        })
        .catch(() => {
          Message.info('已取消上架')
        });
    },
    /** 下架媒资 */
    handleTakeOff(id) {
      this.$confirm("此操作将下架该媒资, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          /** 下架媒资 */
          const res = await takeOffMedia(id);
          if (res.data.code === 200) {
            Message.success('下架成功')
            this.loadMediaData();
          } else {
            Message.error('下架失败')
          }
        })
        .catch(() => {
          Message.info('已取消下架')
        });
    },
    /** 关联媒资 */
    /** 关联多选框 */
    handleSelectionChange(selection, row) {
      /** 如果row没有值 认为是全选 */
      //关联的id数组
      this.correlateIds = selection;
      this.selectMedia = selection;
      /** 改为for循环 */
      for (let i = 0; i < this.correlateData.length; i++) {
        // !row 为全选按钮操作
        if (!row) {
          //全选
          if (selection.length > 0) {
            this.correlateData[i].hasRelated = true;
          } else {
            //取消全选
            this.correlateData[i].hasRelated = false;
          }
        } else {
          if (this.correlateData[i].id === row.id) {
            this.correlateData[i].hasRelated = !row.hasRelated;
          }
        }
      }
    },
    /** 主媒资开关 */
    handlePrimary(data) {
      this.correlateData.forEach(element => {
        if (element.id === data.id) {
          element.primary = data.primary;
        }
      });
    },
    /** 关联对话框 */
    async handleCorrelate(id) {
      //获取关联媒资
      const res = await getCorrelateMedia(id);
      const correlateData = res.data.data;
      correlateData.forEach(async item => {
        item.sourceType =
          item.sourceType === 1
            ? "腾讯"
            : item.sourceType === 2
              ? "优酷"
              : item.sourceType === 3
                ? "爱奇艺"
                : item.sourceType === 8
                  ? "Bilibili"
                  : "未知来源";
      });
      this.correlateData = correlateData;
      this.correlateDialog = true;
      this.$nextTick(() => {
        correlateData.forEach(async item => {
          this.$refs.mediaTable.toggleRowSelection(item, item.hasRelated);
        });
      });
    },
    /** 取消关联 */
    correlateDialogCancel() {
      this.correlateData = [];
      this.correlateDialog = false;
    },
    /** 确定关联 */
    async correlateDialogConfirm() {
      /** 判断主媒资是否唯一 */
      this.primaryCount = 0;
      /** 改为用for循环 */
      /** 主媒资且未关联自身 */
      for (let i = 0; i < this.correlateData.length; i++) {
        if (this.correlateData[i].primary) {
          this.primaryCount++;
          if (!this.correlateData[i].hasRelated) {
            Message.error('主媒资仅有一个且需要关联自身!')
            return;
          }
        }
      }
      if (this.primaryCount !== 1 || !this.selectMedia.length) {
        Message.error('主媒资仅有一个且需要关联自身!')
        return;
      } else {
        this.correlateData.forEach(item => {
          if (item.primary) {
            this.primaryId = item.id;
          }
        });
        const correlateList = this.correlateIds.map(item => {
          return {
            mediaId: item.id,
            primaryMediaId: this.primaryId
          };
        });
        const res = await setCorrelateMedia(correlateList);
        /** 如果关联成功 */
        if (res.data.code === 200) {
          Message.success('关联成功')
          this.correlateDialog = false;
          this.loadMediaData();
        } else {
          Message.error('关联失败')
        }
      }
    },
    /** 确认编辑媒资信息 */
    async editDialogConfirm() {
      /** 让它失去响应 */
      const updateParams = JSON.parse(JSON.stringify(this.editForm));
      /** 类型转换为int */
      updateParams.mediaAsset.type =
        updateParams.mediaAsset.type === "电视剧"
          ? 1
          : updateParams.mediaAsset.type === "电影"
            ? 2
            : updateParams.mediaAsset.type === "综艺"
              ? 3
              : updateParams.mediaAsset.type === "少儿"
                ? 4
                : 0;
      updateParams.mediaAsset.sourceType =
        updateParams.mediaAsset.sourceType === "腾讯"
          ? 1
          : updateParams.mediaAsset.sourceType === "优酷"
            ? 2
            : updateParams.mediaAsset.sourceType === "爱奇艺"
              ? 3
              : updateParams.mediaAsset.sourceType === "Bilibili"
                ? 8
                : 0;
      updateParams.mediaAsset.primary =
        updateParams.mediaAsset.primary === "是" ? true : false;
      updateParams.mediaAsset.status =
        updateParams.mediaAsset.status === "上架" ? 1 : 0;

      /** 处理演员职务转为int */
      updateParams.staffMembers.forEach(item => {
        item.position =
          item.position === "演员"
            ? 1
            : item.position === "导演"
              ? 2
              : item.position === "编剧"
                ? 3
                : 4;
      });
      /** 处理单集时长00:12:51变为1524s这样的格式 */
      updateParams.episodes.forEach(item => {
        const duration = item.duration.split(":");
        const seconds =
          parseInt(duration[0]) * 3600 +
          parseInt(duration[1]) * 60 +
          parseInt(duration[2]);
        item.duration = seconds;
        /** 剧集类型转为int */
        item.episodeType =
          item.episodeType === "正片"
            ? 1
            : item.episodeType === "预告片"
              ? 2
              : 3;
      });

      /** 如果表单校验通过 */
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          const res = await updateMedia(updateParams);
          /** 如果编辑成功 */
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "更新媒资信息成功!"
            });

            /** 关闭编辑对话框 */
            this.editDialog = false;
            this.loadMediaData();
          } else {
            this.$message({
              type: "error",
              message: "更新媒资信息失败!"
            });
            return false;
          }
        } else {
          this.$message({
            type: "error",
            message: "请填写必填字段！"
          });
        }
      });
    },
    /** 关闭查看/编辑对话框 */
    closeDialog() {
      /** 关闭对话框 */
      this.editDialog = false;
      /** 禁止编辑 */
      this.disabled = false;
      /** 重置表单验证 */
      this.$refs.editForm.resetFields();
      /** 设置初始值 */
      this.editForm = this.initData;
    },
    /** 关闭查看/编辑对话框 */
    dialogCancel() {
      this.editDialog = false;
      this.disabled = false;
      /** 重置表单验证 */
      this.$refs.editForm.resetFields();
      this.editForm = this.initData;
    },
    /** 回填媒资数据 */
    async backFillData(id) {
      const res = await getMediaDetail(id);
      console.log("回填媒资接口的响应", res.data.data);
      /** 数据处理 */
      const list = res.data.data;
      /** 处理封面图和高清横屏图 */
      list.mediaAsset.isShowCoverImage = true;
      list.mediaAsset.isShowHdImage = true;
      list.mediaAsset.type =
        list.mediaAsset.type === 1
          ? "电视剧"
          : list.mediaAsset.type === 2
            ? "电影"
            : list.mediaAsset.type === 3
              ? "综艺"
              : list.mediaAsset.type === 4
                ? "少儿"
                : "未知来源";
      list.mediaAsset.sourceType =
        list.mediaAsset.sourceType === 1
          ? "腾讯"
          : list.mediaAsset.sourceType === 2
            ? "优酷"
            : list.mediaAsset.sourceType === 3
              ? "爱奇艺"
              : list.mediaAsset.sourceType === 8
                ? "Bilibili"
                : "未知来源";
      (list.mediaAsset.primary =
        list.mediaAsset.primary === true ? "是" : "否"),
        (list.mediaAsset.status =
          list.mediaAsset.status === 1 ? "上架" : "下架");
      list.mediaAsset.coverImage.replace(/"/g, "");
      list.mediaAsset.hdImage.replace(/"/g, "");
      /** 处理演员职务 */
      list.staffMembers.forEach(item => {
        item.position =
          item.position === 1
            ? "演员"
            : item.position === 2
              ? "导演"
              : item.position === 3
                ? "编剧"
                : "其他职务";
        item.isShowIframe = true;
      });
      /** 处理单集时长1452s变为00:12:51这样的格式 */
      list.episodes.forEach(item => {
        const seconds = item.duration;
        const duration = moment.duration(seconds, "seconds");
        item.duration =
          duration
            .hours()
            .toString()
            .padStart(2, "0") +
          ":" +
          duration
            .minutes()
            .toString()
            .padStart(2, "0") +
          ":" +
          duration
            .seconds()
            .toString()
            .padStart(2, "0");
        /** 剧集类型 */
        item.episodeType =
          item.episodeType === 1
            ? "正片"
            : item.episodeType === 2
              ? "预告片"
              : "其他";
      });

      this.editForm = list;
    },
    //^ ^--------------表格相关 end-------------^ ^

    //^ ^--------------新增媒资相关 start-------------^ ^
    /** 取消新增按钮 */
    addDialogCancel() {
      this.addDialog = false;
      this.$refs.addForm.resetFields();
      this.addForm = {};
    },
    /** 确认新增按钮 */
    addDialogConfirm() {
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          const res = await addMediaBySpider(this.addForm);
          if (res.data.code === 200) {
            this.$message({
              type: "info",
              message: "开始通过爬虫新增媒资!"
            });
            /** 开始轮询 */
            this.pollingAddMedia(this.addForm.url);
            this.addDialog = false;
            this.loadMediaData();
          } else {
            this.$message({
              type: "error",
              message: "通过爬虫新增媒资失败!"
            });
            return false;
          }
        } else {
          this.$message({
            type: "error",
            message: "请填写必填字段！"
          });
        }
      });
    },
    /** 轮询查询是否新增成功 */
    async pollingAddMedia(url) {
      // 记录开始时间
      const startTime = Date.now();
      // 一分钟内轮询
      while (Date.now() - startTime < 60000) {
        try {
          // 调用根据url查询媒资的接口
          const res = await getMediaByUrl({ url });
          // 如果查询到数据
          if (res.data.data.id) {
            /** 通过爬虫新增媒资成功 */
            this.$message({
              type: "success",
              message: "通过爬虫新增媒资成功!"
            });
            /** 成功之后重新渲染列表 */
            this.loadMediaData();
            // 结束轮询
            return;
          }
        } catch (error) {
          // 打印错误信息
          throw new Error(error);
        }
        // 等待5秒钟再次轮询
        await new Promise(resolve => setTimeout(resolve, 5000));
      }
      /** 通过爬虫新增媒资失败(超时提示) */
      this.$message({
        type: "error",
        message: "通过爬虫新增媒资失败!"
      });
    },
    //^ ^--------------新增媒资相关 end-------------^ ^

    //^ ^--------------分页相关 start-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchForm.size = val;
      Message.success(`每页 ${val} 条`);
      this.loadMediaData();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchForm.current = val;
      Message.success(`当前页 ${val}`);
      this.loadMediaData();
    }
    //^ ^--------------分页相关 end-------------^ ^
  }
};
</script>

<style lang="scss" scoped>
.showMediaImg {
  width: 100%;
  height: 30%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.showMediaImg-left {
  width: 40%;
  height: 50%;
  margin-right: 1.25rem;
}

.showMediaImg-right {
  margin-right: 75px;
  width: 40%;
  height: 50%;
}

.mediaImg {
  width: 100%;
  height: 100%;
}

.correlate-description {
  width: 32.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
